import {
  put,
  call,
  fork,
  all,
  takeLatest,
  select,
  take
} from "redux-saga/effects";
import * as roomType from "~/store/room/roomType";
import moment from "moment";
import {
  apiRequestRoomList,
  apiRequestRoomDetail,
  apiDoctorTimeSlot
} from "~/store/room/roomApi";
import { getBaseUrl } from "~/utils/getBaseUrl";
import { chain } from "lodash";
// import * as dateAndSpecialistActions from "~/store/dateAndSpecialist/dateAndSpecialistActions";
/* choose hospital list */
function* requestRoomList() {
  try {
    const baseUrl = yield select(state => getBaseUrl(state.hospital));
    const hospitalId = yield select(
      state => state.hospital.selectedHospital.id
    );
    const {
      selectedSpecialist: { id: subjectId },
      selectedDate: vSelectedDate
    } = yield select(state => state.dateAndSpecialist);
    const { info } = yield select(state => state.user);
    const selectedDate = moment(vSelectedDate);
    const response = yield call(
      apiRequestRoomList,
      baseUrl,
      info,
      hospitalId,
      subjectId,
      selectedDate
      // selectedDate.day(),
    );
    const { data } = response;
    if (response.status !== 200 || response.data.error_code)
      throw new Error("Lỗi server!");
    /* xử lý group theo bác sĩ */
    const listDoctor = data.map(item => {
      const {
        doctor: { id }
      } = item;
      return {
        ...item,
        doctor_id: id
      };
    });
    const groupByDoctor = chain(listDoctor)
      .groupBy("doctor_id")
      .toPairs()
      .map(item => {
        let doctorObj = {};
        const listDetail = item[1].map((detailRom, index) => {
          if (index === 0) {
            doctorObj = {
              doctor_id: detailRom.doctor.id,
              doctor: { ...detailRom.doctor },
              name: detailRom.name,
              hospital_id: detailRom.hospital_id
            };
          }
          return {
            id: detailRom.id,
            ptime: { ...detailRom.ptime },
            changed_doctor: detailRom.changed_doctor
          };
        });
        return {
          ...doctorObj,
          listDetail
        };
      })
      .value();
    yield put({
      type: roomType.REQUEST_UMC_ROOM_LIST_SUCCESS,
      data: groupByDoctor
    });
  } catch (errors) {
    yield put({
      type: roomType.REQUEST_UMC_ROOM_LIST_FAIL,
      errors
    });
  }
}

function* requestRoomDetail() {
  try {
    const baseUrl = yield select(state => getBaseUrl(state.hospital));
    const hospitalId = yield select(
      state => state.hospital.selectedHospital.id
    );
    const {
      selectedSpecialist: { id: subjectId },
      selectedDate: vselectedDate
    } = yield select(state => state.dateAndSpecialist);
    const { info } = yield select(state => state.user);
    const {
      selectedRoomAndDoctor: {
        listDetail,
        // id: roomId,
        doctor: { id: doctorId }
      }
    } = yield select(state => state.doctorAndTime);
    // eslint-disable-next-line no-unused-expressions
    const selectedDate = moment(vselectedDate);
    let listTimeByBuoi = [];
    for (const room of listDetail) {
      const response = yield call(
        apiRequestRoomDetail,
        baseUrl,
        info,
        hospitalId,
        subjectId,
        selectedDate,
        room.id,
        doctorId
      );
      const { data } = response;
      listTimeByBuoi = [
        ...listTimeByBuoi,
        {
          room,
          timeList: data
        }
      ];
    }
    yield put({
      type: roomType.SELECTED_ROOM_AND_DOCTOR_SUCCESS,
      data: listTimeByBuoi
    });
    // const response = yield call(
    //   apiRequestRoomDetail,
    //   baseUrl,
    //   info,
    //   hospitalId,
    //   subjectId,
    //   selectedDate,
    //   selectedDate.day(),
    //   roomId,
    //   doctorId,
    // );
    // const { data } = response;
    // if (response.status !== 200 || response.data.error_code)
    //   throw new Error('Lỗi server!');
  } catch (errors) {
    yield put({
      type: roomType.SELECTED_ROOM_AND_DOCTOR_FAIL,
      errors
    });
  }
}

function* requestDoctorTimeSlot() {
  try {
    const baseUrl = yield select(state => getBaseUrl(state.hospital));
    const hospitalId = yield select(
      state => state.hospital.selectedHospital.id
    );
    const {
      selectedSpecialist: { id: subjectId },
      selectedDate
    } = yield select(state => state.dateAndSpecialist);
    const { info } = yield select(state => state.user);
    const {
      selectedRoomAndDoctor: {
        id: roomId,
        doctor: { id: doctorId }
      }
    } = yield select(state => state.doctorAndTime);
    const response = yield call(
      apiDoctorTimeSlot,
      baseUrl,
      info,
      hospitalId,
      subjectId,
      selectedDate,
      selectedDate.day(),
      roomId,
      doctorId
    );
    const { data: slot_time } = response;
    if (response.status !== 200 || response.data.error_code)
      throw new Error("Lỗi server!");
    yield put({
      type: roomType.GET_DOCTOR_TIME_SLOT_SUCCESS,
      data: slot_time
    });
  } catch (errors) {
    // console.log(errors);
    yield put({
      type: roomType.GET_DOCTOR_TIME_SLOT_FAILURE,
      errors
    });
  }
}

function* requestTimeSlotInDoctorFlow() {
  try {
    const baseUrl = yield select(state => getBaseUrl(state.hospital));
    const hospitalId = yield select(
      state => state.hospital.selectedHospital.id
    );
    const {
      selectedSpecialist: { id: subjectId },
      selectedDate
    } = yield select(state => state.dateAndSpecialist);
    const { info } = yield select(state => state.user);
    const { selectedDoctor } = yield select(state => state.doctor);

    let roomId = [];

    if (hospitalId === 2) {
      roomId = selectedDoctor.detail
        .filter(item => parseInt(item.ptime.weekday) === selectedDate.day())
        .map(item => item.id)
        .join(",");
    }

    const response = yield call(
      apiDoctorTimeSlot,
      baseUrl,
      info,
      hospitalId,
      subjectId,
      selectedDate,
      selectedDate.day(),
      roomId,
      selectedDoctor.doctor.id
    );
    const { data } = response;

    if (response.status !== 200 || response.data.error_code)
      throw new Error("Lỗi server!");
    yield put({
      type: roomType.GET_DOCTOR_TIME_SLOT_SUCCESS,
      data
    });
  } catch (errors) {
    yield put({
      type: roomType.GET_DOCTOR_TIME_SLOT_FAILURE,
      errors
    });
  }
}

function* watchRequestTimeSlotInDoctorFlow() {
  yield takeLatest(
    roomType.REQUEST_TIME_SLOT_IN_DOCTOR_FLOW,
    requestTimeSlotInDoctorFlow
  );
}

function* watchRequestRoomList() {
  yield takeLatest(roomType.REQUEST_UMC_ROOM_LIST, requestRoomList);
}

function* watchSelectedRoomAndDoctor() {
  yield takeLatest(roomType.SELECTED_ROOM_AND_DOCTOR, requestRoomDetail);
}

function* watchGetDoctorTimeSlot() {
  yield takeLatest(
    roomType.GET_DOCTOR_TIME_SLOT_REQUEST,
    requestDoctorTimeSlot
  );
}

function* triggerSubmitDoctorAndTime() {
  while (yield take(roomType.SUBMIT_DOCTOR_AND_TIME)) {
    // yield put(dateAndSpecialistActions.resetSelectDateAndSpecialist());
    // yield put(dateAndSpecialistActions.selectedSpecialist({}));
    // nếu reset date và chuyên khoa --> selectedDate === undefined --> chọn ngày hiện tại --> payment bị lỗi
    // nếu không reset gì cả: payment ok, nhưng trong patientInfomationBooking, mảng summaryinfo[0] vẫn tồn tại chuyên khoa --> show dư ra 1 dòng
    // -> chỉ reset chuyên khoa - không reset date
  }
  console.log("trigger submit doctor and time");
}

export default function* root() {
  yield all([
    fork(watchRequestRoomList),
    fork(watchSelectedRoomAndDoctor),
    fork(watchGetDoctorTimeSlot),
    fork(watchRequestTimeSlotInDoctorFlow),
    fork(triggerSubmitDoctorAndTime)
  ]);
}
